import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from '../scenes/dashboard';
import Role from '../admin/container/Role/Role';
import Category from '../admin/container/Category/Category';
import Subcategory from '../admin/container/Subcategory/Subcategory';
import ListProducts from '../admin/container/Product/ListProducts';
import Vendor from '../admin/container/Vendor/Vendor';
import Warehouse from '../admin/container/Warehouse/Warehouse';
import User from '../admin/container/User/User';
import Auth from '../admin/container/Auth/Auth';
import Product from '../admin/container/Product/Product';
import ResponsiveDrawer from '../admin/component/Layout/ResponsiveDrawer';
import Logout from '../admin/container/Auth/Logout';
import Liasoning from '../admin/container/Liasoning/Liasoning';
import Marketing from '../admin/container/Marketing/Marketing';
import ListMarket from '../admin/container/Marketing/ListMarket';
import AddWarehouse from '../admin/container/Warehouse/AddWarehouse';
import AddVendor from '../admin/container/Vendor/AddVendor';
import AddDealer from '../admin/container/Dealer/Adddealer';
import ListDealer from '../admin/container/Dealer/Listdealer';
import PandingMarket from '../admin/container/Marketing/PandingMarket';
import AddSidebar from '../admin/container/SidebarName/AddSidebar';
import Purchase from '../admin/container/Purchase/Purchase';
import ListPurchase from '../admin/container/Purchase/ListPurchase';
import Addterms from '../admin/container/TermsCondition/Addterms';
import PendingPo from '../admin/container/Store/PendingPo';
import Items from '../admin/container/Store/Items';
import AddStore from '../admin/container/Store/AddStore';
import Account from '../admin/container/Account/Account';
import Addaccount from '../admin/container/Account/Addaccount';
import Dealerpayment from '../admin/container/Account/Dealerpayment';
import Commision from '../admin/container/Dealer/Commision';
import Dealerpaymentshow from '../admin/container/Account/Dealerpaymentshow';
import Venderpayment from '../admin/container/Account/Venderpayment';
import AddVendorPayment from '../admin/container/Account/AddVendorPayment';
import KitProduct from '../admin/container/Dispatch/KitProduct';
import AddKitProduct from '../admin/container/Dispatch/AddKitProduct';
import StockTransfer from '../admin/container/Dispatch/StockTransfer';
import Addstocltransfer from '../admin/container/Dispatch/Addstocltransfer';
import DispatchSuggestion from '../admin/container/Dispatch/DispatchSuggestion';
import AddDispatchSuggestion from '../admin/container/Dispatch/AddDispatchSuggestion';
import DispatchProcess from '../admin/container/Dispatch/DispatchProcess';
import AddDispatchProcess from '../admin/container/Dispatch/AddDispatchProcess';
import BulkDispatch from '../admin/container/Dispatch/BulkDispatch';
import AssignInstaller from '../admin/container/AssignToInstaller/AssignInstaller';
import AddAssignInstaller from '../admin/container/AssignToInstaller/AddAssignInstaller';
import Electrician from '../admin/container/Installer/Electrician';
import Fabricator from '../admin/container/Installer/Fabricator';
import Payment from '../admin/container/Installer/Payment';
import AddFabricator from '../admin/container/Installer/AddFabricator';
import AddElectrician from '../admin/container/Installer/AddElectrician';
import InstallerPayment from '../admin/container/Account/InstallerPayment';
import AddInstaller from '../admin/container/Account/AddInstaller';
import BillofMaterial from '../admin/container/Bom/BillofMaterial';
import AddBillofMaterial from '../admin/container/Bom/AddBillofMaterial';
import Sales from '../admin/container/Bom/Sales';
import AddSales from '../admin/container/Bom/AddSales';
import Addliasoning from '../admin/container/Liasoning/Addliasoning';
function AdminRoutes(props) {
    const [isSidebar, setIsSidebar] = useState(true);

    return (
        <>
            <ResponsiveDrawer isSidebar={isSidebar} />
            <main className="content">

                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route exact path='/role' element={<Role />} />
                    <Route path="/category" element={<Category />} />
                    <Route exact path='/sub-category' element={<Subcategory />} />
                    <Route exact path='/add-product' element={<Product />} />
                    <Route exact path='/list-of-product' element={<ListProducts />} />

                    <Route exact path='/add-liasoning' element={<Addliasoning />} />
                    <Route exact path='/liasoning' element={<Liasoning />} />

                    <Route exact path='/add-market' element={<Marketing />} />
                    <Route exact path='/list-of-customer' element={<ListMarket />} />
                    <Route exact path='/pending-marketing' element={<PandingMarket />} />

                    <Route exact path='/side-bar' element={<AddSidebar />} />

                    <Route exact path='/terms-&-conditions' element={<Addterms />} />
                    <Route exact path='/purchase' element={<ListPurchase />} />
                    <Route exact path='/add-purchase' element={<Purchase />} />

                    <Route exact path='/customer-payment' element={<Account />} />
                    <Route exact path='/dealer-payment-show' element={<Dealerpaymentshow />} />
                    <Route exact path='/add-account' element={<Addaccount />} />
                    <Route exact path='/customer-list' element={<ListDealer />} />
                    <Route exact path='/commision' element={<Commision />} />
                    <Route exact path='/add-dealer' element={<AddDealer />} />
                    <Route exact path='/vendors' element={<Vendor />} />
                    <Route exact path='/add-vendor' element={<AddVendor />} />
                    <Route exact path='/warehouses' element={<Warehouse />} />
                    <Route exact path='/add-warehouses' element={<AddWarehouse />} />
                    <Route exact path='/pending-po' element={<PendingPo />} />
                    <Route exact path='/add-store' element={<AddStore />} />
                    <Route exact path='/items' element={<Items />} />
                    <Route exact path='/dealer-payment' element={<Dealerpayment />} />

                    <Route exact path='/vendor-payment' element={<Venderpayment />} />
                    <Route exact path='/add-vendor-payment' element={<AddVendorPayment />} />

                    <Route exact path='/kit-product' element={<KitProduct />} />
                    <Route exact path='/add-Kit-Product' element={<AddKitProduct />} />

                    <Route exact path='/dispatch-suggestion' element={<DispatchSuggestion />} />
                    <Route exact path='/add-dispatch-suggestion' element={<AddDispatchSuggestion />} />


                    <Route exact path='/stock-transfer' element={<StockTransfer />} />
                    <Route exact path='/add-stock-transfer' element={<Addstocltransfer />} />

                    <Route exact path='/dispatch-process' element={<DispatchProcess />} />
                    <Route exact path='/add-dispatch-process' element={<AddDispatchProcess />} />
                    <Route exact path='/bulk-dispatch' element={<BulkDispatch />} />

                    <Route exact path='/assign-to-installer' element={<AssignInstaller />} />
                    <Route exact path='/add-assign-installer' element={<AddAssignInstaller />} />

                    <Route exact path='/fabricator' element={<Fabricator />} />
                    <Route exact path='/add-fabricator' element={<AddFabricator />} />

                    <Route exact path='/electrician' element={<Electrician />} />
                    <Route exact path='/add-electrician' element={<AddElectrician />} />

                    

                    <Route exact path='/payment' element={<Payment />} />
                    <Route exact path='/installer-payment' element={<InstallerPayment />} />
                    <Route exact path='/add-installer' element={<AddInstaller />} />

                    <Route exact path='/sales' element={<Sales />} />
                    <Route exact path='/add-sales' element={<AddSales />} />

                    <Route exact path='/bill-of-material' element={<BillofMaterial />} />
                    <Route exact path='/add-bom' element={<AddBillofMaterial />} />

                    <Route exact path='/user' element={<User />} />
                    <Route exact path='/login' element={<Auth />} />
                    <Route exact path='/logout' element={<Logout />} />
                </Routes>
            </main>
        </>
    );
}

export default AdminRoutes;